import React from 'react'

const ExplorePage = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-slate-900 text-white text-3xl font-bold">
        EXPLORE PAGE FOR REAL
    </div>
  )
}

export default ExplorePage;